/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BatchStatus {
    PENDING = 'Pending',
    CANCELED = 'Canceled',
    PROCESSED = 'Processed',
}